import React from 'react';
import { Animated } from 'react-animated-css';

class MedalCard extends React.Component {
    state = { toggled: false }
    toggle = () => this.setState({ toggled: !this.state.toggled && this.props.medal.Description });
    render() {
        const { toggled } = this.state, { medal, index } = this.props;
        return <Animated animationIn="slideInUp" animationInDelay={index * 50}><figure className="card w3-card p-4 medal-card m-2" style={{ overflow: 'auto' }} onClick={this.toggle}>
            <div className={`d-flex flex-column w-100 h-100 justify-content-${toggled ? 'start' : 'center'}`}>
                {!toggled && <img alt="" className="align-self-center" src={medal.Medal} style={{ maxWidth: 140 }} />}
                {!toggled && <span className="font-14 align-self-center anton black margin-top-half">{medal.Name}</span>}
                {toggled && <span className="hind font-8 gray align-self-center">{medal.Description}</span>}
            </div>
        </figure>
        </Animated>
    }
}

export default MedalCard;


// WEBPACK FOOTER //
// ./src/components/information/partials/medal_card.js